import { useEffect, useState } from "react";
import Api from "lib/api/httpRequestHelper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close, LocalShipping, Room, Store } from "@mui/icons-material";
import LoadingData from "components/Loading/LoadingData";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

export default function AddressCard({ storeId, setOpenedModal, setType }) {
  const [searching, setSearching] = useState(false);
  const [address, setAddress] = useState();

  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);
    try {
      const response = await Api.get(
        "store",
        "commercialstructure",
        "?idPessoaLoja=" + storeId + "&idMarca=" + 1,
        true
      );

      console.log(response.Result[0]);
      setAddress(response.Result[0]);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar informações de endereços:", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const principal = [
    { label: "CNPJ", value: address?.EndPrincipalCnpj },
    { label: "Logradouro", value: address?.EndPrincipalRua },
    { label: "Número", value: address?.EndPrincipalNumero },
    { label: "Bairro", value: address?.EndPrincipalBairro },
    { label: "Cidade", value: address?.EndPrincipalCidade },
    { label: "UF", value: address?.EndPrincipalUf },
    { label: "CEP", value: address?.EndPrincipalCep },
    { label: "Complemento", value: address?.EndPrincipalComplemento },
  ];

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open onClose={() => setOpenedModal(null)} maxWidth={"md"}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Room style={{ marginRight: "12px" }} />
            Meus endereços
          </Typography>
          <IconButton onClick={() => setOpenedModal(null)}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando dados de endereço..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                color="primary"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                Principal
                <Store style={{ marginLeft: 8 }} />
              </Typography>

              <Divider />

              {principal?.map(({ label, value }) => (
                <Typography key={label} variant="caption">
                  <strong>{label}:</strong> {value}
                </Typography>
              ))}
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                color="primary"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                Entrega
                <LocalShipping style={{ marginLeft: 8 }} />
              </Typography>

              <Divider />

              {principal?.map(({ label, value }) => (
                <Typography key={label} variant="caption">
                  <strong>{label}:</strong> {value}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </DialogContent>
      )}

      <DialogActions>
        <Button
          variant="outlined"
          style={{ marginTop: "1.5rem" }}
          onClick={() => setOpenedModal(null)}
        >
          Fechar
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: "1.5rem" }}
          onClick={() => {
            setOpenedModal("ALTERACAO");
            setType("ADDRESS");
          }}
        >
          Solicitar alteração
        </Button>
      </DialogActions>
    </Dialog>
  );
}
